export const top_courses = [{
        image: 'https://picsum.photos/id/237/200/300',
        name: 'Marketing Crash Course',
        joined: 50,
        completed: 45,
        in_progress: 5
    },
    {
        image: 'https://picsum.photos/id/238/200/300',
        name: 'Personality Development',
        joined: 45,
        completed: 40,
        in_progress: 5
    },
    {
        image: 'https://picsum.photos/id/236/200/300',
        name: 'Basics of Trading',
        joined: 65,
        completed: 45,
        in_progress: 20
    },
    {
        image: 'https://picsum.photos/id/247/200/300',
        name: 'Public Relation Course',
        joined: 75,
        completed: 50,
        in_progress: 25
    },
    {
        image: 'https://picsum.photos/id/257/200/300',
        name: 'Branding Course',
        joined: 50,
        completed: 45,
        in_progress: 5
    }
]

export const top_quizzes = [{
        name: 'Quiz Masters',
        joined: 50,
        completed: 45,
        in_progress: 5
    },
    {
        name: 'The Winning Team',
        joined: 50,
        completed: 45,
        in_progress: 5
    },
    {
        name: 'Boom Blast',
        joined: 50,
        completed: 45,
        in_progress: 5
    },
    {
        name: 'Quiz on important Topic',
        joined: 50,
        completed: 45,
        in_progress: 5
    },
    {
        name: 'Thought Rattle',
        joined: 50,
        completed: 45,
        in_progress: 5
    }
]

export const participants = [{
        name: 'Jane Cooper',
        completed_sessions: '15/30',
        quiz_completed: '10/16',
        live_class_attended: '17/20',
        score_level: '75',
        points_earned: '50',
        certificates: '3/5'
    },
    {
        name: 'Wade Warren',
        completed_sessions: '12/30',
        quiz_completed: '10/16',
        live_class_attended: '16/32',
        score_level: '70',
        points_earned: '45',
        certificates: '2/5'
    },
    {
        name: 'Eleanor Pena',
        completed_sessions: '10/30',
        quiz_completed: '9/16',
        live_class_attended: '14/32',
        score_level: '60',
        points_earned: '40',
        certificates: '2/5'
    },
    {
        name: 'Jenny Wilson',
        completed_sessions: '08/30',
        quiz_completed: '08/16',
        live_class_attended: '12/32',
        score_level: '65',
        points_earned: '38',
        certificates: '4/5'
    },
    {
        name: 'Guy Hawkins',
        completed_sessions: '07/30',
        quiz_completed: '07/16',
        live_class_attended: '11/32',
        score_level: '55',
        points_earned: '35',
        certificates: '2/5'
    },
    {
        name: 'Robert Fox',
        completed_sessions: '06/30',
        quiz_completed: '06/16',
        live_class_attended: '09/32',
        score_level: '50',
        points_earned: '27',
        certificates: '4/5'
    },
    {
        name: 'Jerome Bell',
        completed_sessions: '05/30',
        quiz_completed: '05/16',
        live_class_attended: '08/32',
        score_level: '45',
        points_earned: '25',
        certificates: '3/5'
    },
    {
        name: 'Floyd Miles',
        completed_sessions: '04/30',
        quiz_completed: '04/16',
        live_class_attended: '07/32',
        score_level: '40',
        points_earned: '22',
        certificates: '2/5'
    },
    {
        name: 'Devon Lane',
        completed_sessions: '03/30',
        quiz_completed: '03/16',
        live_class_attended: '05/32',
        score_level: '35',
        points_earned: '20',
        certificates: '1/5'
    },
    {
        name: 'Darrell Steward',
        completed_sessions: '02/30',
        quiz_completed: '01/16',
        live_class_attended: '02/32',
        score_level: '30',
        points_earned: '15',
        certificates: '0/5'
    }
]

export const live_classes = [{
        id: '1',
        cover_image_url: 'https://img.youtube.com/vi/QoAOzMTLP5s/sddefault.jpg',
        title: 'Business Canvas Model',
        trainer_name: "Tyav Moses",
        date: 'Sep 21, 2021',
        start_time: '10:00 AM',
        duration: '90',
        link: 'https://www.google.com',
    },
    {
        id: '2',
        cover_image_url: 'https://img.youtube.com/vi/BPK_qzeH_yk/sddefault.jpg',
        title: `Do's and Don'ts of Marketing`,
        trainer_name: "Arnav Puri",
        date: 'Sep 20, 2021',
        start_time: '09:45 AM',
        duration: '60',
        link: 'https://www.google.com',
    },
    {
        id: '3',
        cover_image_url: 'https://img.youtube.com/vi/hZLMv5aexto/sddefault.jpg',
        title: 'Key Points of Marketing',
        trainer_name: "Mark Mclaren",
        date: 'Sep 18, 2021',
        start_time: '11:30 AM',
        duration: '45',
        link: 'https://www.google.com',
    },
    {
        id: '4',
        cover_image_url: 'https://img.youtube.com/vi/CMGhDjXzTsY/sddefault.jpg',
        title: 'Fundamentals of Marketing',
        trainer_name: "Pawan Singh",
        date: 'Sep 17, 2021',
        start_time: '01:30 PM',
        duration: '90',
        link: 'https://www.google.com',
    },
]

export const leadership_board = [{
        name: 'Jane Cooper',
        image: '/images/people/1.jpg',
        score: 90
    },
    {
        name: 'Wade Warren',
        image: '/images/people/2.jpg',
        score: 88
    },
    {
        name: 'Devon Lane',
        image: '/images/people/3.jpg',
        score: 85
    },
    {
        name: 'Guy Hawkins',
        image: '/images/people/4.jpg',
        score: 80
    },
    {
        name: 'Jenny Wilson',
        image: '/images/people/6.jpg',
        score: 70
    },
    {
        name: 'Leslie Fox',
        image: '/images/people/8.jpg',
        score: 67
    },
    {
        name: 'Cody Fisher',
        image: '/images/people/15.jpg',
        score: 65
    },
    {
        name: 'Bessie Cooper',
        image: '/images/people/5.jpg',
        score: 60
    },
    {
        name: 'Albert Flores',
        image: '/images/people/7.jpg',
        score: 55
    },
    {
        name: 'Ronald Richards',
        image: '/images/people/10.jpg',
        score: 50
    }
]

export const announcements = [{
        date: '15',
        title: 'Most Favorite Course',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor odio lobortis mattis lacinia at commodo ultricies.'
    },
    {
        date: '10',
        title: 'Quiz for Marketing Course is Going to Expire',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor odio lobortis mattis lacinia at commodo ultricies.'
    },
    {
        date: '09',
        title: 'New Course is Added',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor odio lobortis mattis lacinia at commodo ultricies.'
    }
]